module.exports = __webpack_public_path__ + "img/signin.34b0424d.svg";